import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { CheckoutResponse } from '~client/model/checkout-response';
import { DrawOfferRequest } from '~client/model/draw-offer-request';
import { DrawResponse } from '~client/model/draw-response';
import { ResponseEntity } from '~client/model/response-entity';

/*
Draw means Wishlists Yoops
User APIs pertaining to Lists/Draws
*/
export class DrawController extends BaseController {
  /* Allows the user remove a draw entry for the given offer group */
  public deleteEntry$(offerGroupId: string): Observable<ResponseEntity> {
    return this.put$(`/draw/deleteEntry?offerGroupId=${offerGroupId}`);
  }

  /* Returns the fees and taxes for this draw request */
  public reviewEntry(request: DrawOfferRequest, isPublic: boolean): Promise<CheckoutResponse> {
    return this.put(isPublic ? '/draw/public/checkout' : '/draw/checkout', request);
  }

  /* Allows the enter the draw for the given offer group */
  public submitEntry(request: DrawOfferRequest): Promise<DrawResponse> {
    return this.post('/draw/entry', request);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/controller/draw-controller.ts